let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ePm95")).then(() => parcelRequire('aPaXw'));